<header
  [class]="'p-4 bg-[#23252e] flex items-center justify-between mx-auto fixed left-0 w-full top-0 z-99'"
  [ngStyle]="{ paddingTop: paddingTop }">
  <img [src]="`/logo-${language()}.svg`" width="94" height="36" class="w-[94px] h-9 object-contain object-center" alt="PatricGames" />

  <div class="flex items-center">
    <div class="flex items-center mr-4 md:mr-10" [routerLink]="['/', 'profile']">
      <hlm-avatar class="w-7.5 h-7.5 mr-2 md:w-12.5 md:h-12.5 md:mr-3.5">
        <img [src]="vm().user?.photo_url ?? '/avatar-1.jpg'" alt="spartan logo. Resembling a spartanic shield" hlmAvatarImage />
        <span class="text-white bg-[#2F7FFE]" hlmAvatarFallback [autoColor]="false"></span>
      </hlm-avatar>
      <span class="text-sm font-medium text-ellipsis line-clamp-1 max-w-[75px]"> {{ userDisplayName() }} </span>
    </div>

    <div
      [routerLink]="['/', 'profile']"
      [queryParams]="{ openBalance: true }"
      class="px-[13px] py-[7.5px] bg-[#343843] text-sm leading-[13px] font-medium rounded-2xl flex items-center md:text-xl md:leading-[23px] md:py-[15px] md:px-7 md:rounded-[26px]"
    >
      <img src="/stars.svg" width="14" height="13" class="mr-1.5 md:w-5" alt="Stars" />
      {{ balanceVm().balance }}
    </div>
  </div>
</header>
<div class="h-17 bg-[#23252e]" [ngStyle]="{ height: backdropHeight }"></div>
